import React from 'react'
import classNames from 'classnames'

import styles from './VerificationStatus.scss'

export interface VerificationStatusProps {
    status: 'success' | 'failed' | 'pending'
    className?: string
}

export const VerificationStatus: React.FC<VerificationStatusProps> = ({
    status,
    className
}) => {
    const getStatusText = () => {
        switch (status) {
            case 'success':
                return 'Successful'
            case 'failed':
                return 'Failed'
            case 'pending':
                return 'Pending'
            default:
                return status
        }
    }

    const getStatusClassName = () => {
        switch (status) {
            case 'success':
                return styles.successText
            case 'failed':
                return styles.warningText
            case 'pending':
                return styles.pendingText
            default:
                return ''
        }
    }

    return (
        <span className={classNames(className)}>
            <strong>
                Verification - <span className={getStatusClassName()}>{getStatusText()}</span>
            </strong>
        </span>
    )
}